import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";

export default function SearchBox({ value, onChange, placeholder = "Buscar…", testId }) {
  return (
    <div className="relative w-full max-w-sm">
      <Search className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
      <Input
        data-testid={testId || "search-input"}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="pl-9 h-10 rounded-lg"
      />
    </div>
  );
}
